import BilliardLoader from "./BilliardLoader";

/**
 * Màn chờ chặn thao tác, dùng chung cho mọi trang qua loaderState.
 *
 * Trước đây là một vòng tròn xoay của tw-elements; đổi sang viên bi số 8 để
 * cả app cùng một hình ảnh chờ. Giao diện bên ngoài giữ nguyên nên 26 trang
 * đang bật loaderState không phải sửa gì.
 */
const Loader = () => <BilliardLoader variant="screen" />;

export default Loader;
